'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isNode() {
    var _process_versions, _process;
    return typeof process !== 'undefined' && ((_process = process) === null || _process === void 0 ? void 0 : (_process_versions = _process.versions) === null || _process_versions === void 0 ? void 0 : _process_versions.node) != null;
}
exports.isNode = isNode;
